<div class="page-head">
    <h5 class="header-title text-primary pl-2 pl-md-1 letter-spacing">
        PRESCRIPTION TEMPLATE CREATION
    </h5>
</div>

<form class="form-group" [formGroup]="prescriptionForm">
    <div class="row">
        <div class="col-lg-12">

            <div class="row">
                <div class="text-primary form-group col-md-2"></div>
                <div class="text-primary form-group col-md-2 pt-2" style="text-align: right;">Enter Template
                    Name
                </div>
                <div class="form-group col-md-4"><input name="tmpl_name" class="form-control"
                        formControlName="tmpl_name" type="text"></div>
                <div class="text-primary form-group col-md-4"></div>
            </div>
            <div class="row">
                <div class="text-primary form-group col-md-2"></div>
                <div class="text-primary form-group col-md-2 pt-2" style="text-align: right;">Make this template as
                    Public
                </div>
                <div class="form-group col-md-4">
                    <input type="checkbox" [checked]="consultChecked"
                        (change)="checkValue((consultChecked = !consultChecked))" />
                </div>
                <div class="text-primary form-group col-md-4"></div>
            </div>
            <div class="card m-b-30">
                <div class="card-body">
                    <div formArrayName="pre_template_details">
                        <div class="row" *ngFor="
                        let x of prescriptionForm.get('pre_template_details')[
                          'controls'
                        ];
                        let i = index;
                        trackBy: track
                      " [formGroupName]="i">
                            <div class="col-lg-12">
                                <div class=" form-group  row pt-2">
                                    <div class="col-md-2">
                                        <div class="text-dark"> Medicine Name </div>
                                        <input type="text" formControlName="mname" list="browsers" id="browser"
                                            (keyup)="medicinesFet($event,i)" placeholder="MEDICINE NAME"
                                            class="form-control ">
                                        <div class="row">
                                            <datalist id="browsers">
                                                <option *ngFor="let x of medicineAuo" [value]="x.med_name">
                                                    {{ x.med_name}}
                                                </option>
                                            </datalist>
                                        </div>
                                        <div *ngIf="
                                prescription.at(i).get('mname') &&
                                prescription.at(i).get('mname').hasError('required')
                              " class="invalid-feedback">
                                            This is required
                                        </div>
                                    </div>
                                    <div class=" form-group  col-md-2">
                                        <div class="text-dark"> Medicine Strength </div>
                                        <input type="text" class="form-control" placeholder="Strength (mg/tbsp/ml)"
                                            formControlName="strength" />
                                        <div *ngIf="
                                prescription.at(i).get('strength') &&
                                prescription
                                  .at(i)
                                  .get('strength')
                                  .hasError('required')
                              " class="invalid-feedback">
                                            This is required
                                        </div>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <div class="text-dark"> Intake Type</div>
                                        <select formControlName="intakefreq_type" name="intakefreq_type"
                                            class="form-control" (change)="freqTypeSelected($event, i)">
                                            <option *ngFor="let x of intakeFreqTypesList" [value]="x.value">
                                                {{ x.value }}
                                            </option>
                                        </select>
                                        <div *ngIf="
                                prescription.at(i).get('intakefreq_type') &&
                                prescription
                                  .at(i)
                                  .get('intakefreq_type')
                                  .hasError('required')
                              " class="invalid-feedback">
                                            This is required
                                        </div>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <div class="text-dark"> Intake Frequency</div>
                                        <select formControlName="intakefreq" name="intakefreq" class="form-control">
                                            <option value="null" disabled selected>
                                                Select Frequency
                                            </option>
                                            <option *ngFor="let x of intakefreqList[i]" [value]="x">
                                                {{ x }}
                                            </option>
                                        </select>
                                        <div *ngIf="
                                prescription.at(i).get('intakefreq') &&
                                prescription
                                  .at(i)
                                  .get('intakefreq')
                                  .hasError('required')
                              " class="invalid-feedback">
                                            This is required
                                        </div>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <div class="text-dark"> Intake</div>
                                        <select formControlName="intake" name="intake" class="form-control">
                                            <option value="null" disabled selected>
                                                Select</option>
                                            <option *ngFor="let x of intakeList" [value]="x">
                                                {{ x }}
                                            </option>
                                        </select>
                                        <div *ngIf="
                                prescription.at(i).get('intake') &&
                                prescription.at(i).get('intake').hasError('required')
                              " class="invalid-feedback">
                                            This is required
                                        </div>
                                    </div>
                                    <div class="col-md-2 align-self-center">
                                        <div class="tabledit-toolbar btn-toolbar float-none float-md-right">
                                            <button *ngIf="i > 0" type="button"
                                                class="btn btn-outline-danger mr-2 removeitem"
                                                (click)="removingCurrentPrescription(i)">
                                                <i class="fa fa-close"></i>
                                            </button>
                                            <button type="button" class="tabledit-edit-button btn  btn-success edit"
                                                title="Add More Prescription" (click)="addpPrescription()">
                                                <span class="fa fa-plus"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row pt-3">


                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4"></div>
                        <div class="col-md-4">
                            <button class="btn btn-primary pl-5 pr-5 mr-2 mb-2 mb-md-2 btn-rounded" type="button"
                                [disabled]="prescription.invalid || prescriptionForm.invalid"
                                (click)="sendPrescription()">
                                Save
                            </button>
                            <button class="btn btn-secondary bg-color text-white pl-5 pr-5 mb-2 mb-md-2 btn-rounded"
                                type="button" (click)="gotoPage()">
                                Cancel
                            </button>
                        </div>
                        <div class="col-md-4"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</form>